import { ConfigSection } from "../../components-fabric";
import { buildingDataSection } from "./building-data/screens";
import { componentsSection } from "./components/screens";
import { layoutWorkspace } from '../_common/layout.workspace';
import { dashboardScreen } from './screens.dashboard';
import { presetsSection } from "./presets/presets.screens";

/**
 * Configuration Array: componentsDbScreens
 * 
 * This array contains the configuration for the components database screens. 
 * It includes the main section with its id, title, layout, path, roles, and nested screens and sections.
 * 
 * @property {string} id - The identifier for the main section.
 * @property {string} title - The title of the main section.
 * @property {Object} layout - The layout configuration for the main section.
 * @property {string} path - The URL path for the main section.
 * @property {Array<string>} roles - The roles that have access to this section.
 * @property {Array} screens - An array of screen configurations.
 * @property {Array} sections - An array of nested section configurations.
 */
export const componentsDbScreens: ConfigSection[] = [
  {
    id: "components_db",
    title: "Component database",
    layout: layoutWorkspace,
    path: "components-db",
    roles: ['STUDY_DIRECTOR', 'LECTURER', 'STUDENT'],
    screens: [
      dashboardScreen
    ],
    sections: [
      buildingDataSection,
      componentsSection,
      presetsSection
    ]
  }
];
